import React from "react";
import Loader from "../../../Loader";

// Shown while POST /behavioral-sets/generate is in flight. Same Loader MCQ's
// shared/GeneratingLoader.jsx uses.
const GeneratingLoader = () => (
  <div className="flex flex-col items-center gap-2 py-10">
    <div className="h-16 w-16">
      <Loader />
    </div>
    <p className="text-sm font-medium dark:text-gray-300 text-textSecondary">
      Generating your questions…
    </p>
  </div>
);

export default GeneratingLoader;
